import React from 'react';
import { Step } from 'react-joyride';
import { AddTradesStartContent } from '../../../components/app/onboarding/steps/add-trades/add-trades-start-content';

export const addTradesStartStep: Step = {
    target: 'body',
    placement: 'center',
    disableBeacon: true,
    showSkipButton: true,
    disableOverlayClose: true,
    hideFooter: true,
    content: <AddTradesStartContent />,
};
